var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactsOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 17.738,
    cy: 15.18,
    r: 16.588,
    gradientTransform: "translate(1.876 3.587) scale(0.883 0.883)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d3e9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.155,
    stopColor: "#d3e9ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#4074ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#36486c"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "b",
    cx: 16.275,
    cy: 13.204,
    r: 24.072,
    gradientTransform: "translate(1.876 3.587) scale(0.883 0.883)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.165
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: -43.834,
    cy: 32.11,
    r: 3.715,
    gradientTransform: "matrix(-0.712, 0.522, 0.522, 0.712, -33.154, 15.717)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "d",
    cx: -40.094,
    cy: 5.89,
    r: 3.716,
    gradientTransform: "matrix(-0.923, 0.677, 0.677, 0.923, -15.514, 48.426)",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: -47.798,
    cy: 27.549,
    r: 3.718,
    gradientTransform: "matrix(-0.712, 0.522, 0.522, 0.712, -34.137, 27.609)",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: -39.155,
    cy: 24.378,
    r: 3.714,
    gradientTransform: "matrix(-0.768, 0.564, 0.563, 0.768, -23.312, 18.907)",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: -66.079,
    y1: 35.233,
    x2: -64.583,
    y2: 31.623,
    gradientTransform: "matrix(0.939, -0.879, 0.683, 0.73, 62.332, -55.839)",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: -20.819,
    y1: -4.224,
    x2: -19.39,
    y2: -8.627,
    gradientTransform: "matrix(1.131, 0.613, -0.477, 0.879, 37.258, 40.451)",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: -63.399,
    y1: 32.009,
    x2: -63.547,
    y2: 34.788,
    gradientTransform: "matrix(0.918, -0.859, 0.668, 0.713, 55.895, -58.163)",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: -101.398,
    y1: -62.902,
    x2: -101.052,
    y2: -65.674,
    gradientTransform: "matrix(-1.28, -0.126, 0.098, -0.995, -102.591, -59.054)",
    xlinkHref: "#c"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "folder_type_www_opened") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M27.4,5.5H18.2L16.1,9.7H4.3V26.5H29.5V5.5Zm0,18.7H6.6V11.8H27.4Zm0-14.5H19.2l1-2.1h7.1V9.7Z",
    style: {
      fill: "#7b9bdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "25.7 13.7 0.5 13.7 4.3 26.5 29.5 26.5 25.7 13.7",
    style: {
      fill: "#7b9bdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.086,20.777a9.466,9.466,0,1,1-9.468-9.465h0A9.467,9.467,0,0,1,30.086,20.777Z",
    style: {
      fill: "url(#a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.62,30.49a9.71,9.71,0,1,1,9.711-9.713A9.71,9.71,0,0,1,20.62,30.49Zm0-18.933a9.222,9.222,0,1,0,9.222,9.222v0A9.233,9.233,0,0,0,20.62,11.557Z",
    style: {
      fill: "#39396c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.82,19.362h0l-.261.3a5.579,5.579,0,0,0-.523-.513l-.4.059-.367-.414V19.3l.314.239.209.239.279-.319c.07.132.139.263.21.4v.395l-.314.355-.575.4-.435.434-.279-.319.139-.355-.279-.319-.471-1.006-.4-.454-.112.113.159.572.3.336a13.6,13.6,0,0,0,.558,1.421,7.954,7.954,0,0,0,1.011-.08v.277l-.418,1.026-.383.434-.314.672v1.105l.105.434-.175.2-.384.239-.4.336.332.375-.454.4.087.256-.68.77h-.457l-.383.239h-.245v-.319l-.1-.632c-.135-.4-.276-.79-.418-1.183,0-.29.018-.578.035-.868l.175-.395-.245-.474.018-.651-.332-.375.166-.542-.269-.306H23.37l-.159-.178-.471.3-.191-.218-.436.375-.885-1.011-.348-.829.314-.473-.175-.2.383-.908c.315-.391.643-.768.976-1.145l.593-.159.662-.08.454.119.645.65.226-.256.313-.039.593.2h.455l.314-.277.139-.2-.314-.2-.523-.039a5.26,5.26,0,0,0-.453-.592l-.175.08-.07.513-.314-.355-.069-.4-.348-.276h-.14l.349.395-.139.355-.279.08.175-.355-.314-.159-.278-.319-.524.118-.069.159-.314.2-.175.434-.435.217-.192-.217h-.211v-.705l.454-.239h.348l-.07-.276-.277-.274.47-.1.261-.3.209-.355h.384l-.105-.276L23.878,15v.319l.523.118L24.923,15l.035-.2.453-.319a3.469,3.469,0,0,0-.488.08v-.354l.175-.4h-.175l-.383.355-.105.2.105.277-.175.473-.279-.159-.244-.276-.384.276-.139-.631.662-.434v-.239l.418-.276.662-.159.454.159.836.159-.209.239h-.454l.454.473.348-.395.106-.174a12.378,12.378,0,0,1,2.1,2.508A9.128,9.128,0,0,1,29.82,19.362Z",
    style: {
      fill: "#204a87",
      fillOpacity: 0.7134503126144409
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.187,13.857l-.035.239.245.159.418-.276-.209-.239-.279.159-.139-.04",
    style: {
      fill: "#204a87",
      fillOpacity: 0.7134503126144409
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.571,12.24l-.907-.355L19.618,12l-1.29.355-.244.239.8.552v.319l-.314.319.418.829.278-.159.349-.552a12,12,0,0,0,1.533-.592l.418-1.066",
    style: {
      fill: "#204a87",
      fillOpacity: 0.7134503126144409
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.512,15.554l-.139-.356-.245.08.07.434.314-.159",
    style: {
      fill: "#204a87",
      fillOpacity: 0.7134503126144409
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.653,15.475l-.07.474.383-.08.279-.276L23,15.354a6.436,6.436,0,0,0-.279-.631h-.209v.239l.139.159v.355",
    style: {
      fill: "#204a87",
      fillOpacity: 0.7134503126144409
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.492,22.972l-.279-.552L16.69,22.3l-.279-.749-.7.08-.592-.434-.628.552v.087a2.391,2.391,0,0,1-.592-.167l-.139-.395v-.435l-.418.039q.053-.414.1-.828H13.2l-.244.319-.244.118-.345-.2-.035-.434.07-.473.523-.395h.414l.069-.239.523.118.383.474.07-.79L15.051,18l.244-.592.488-.2.279-.395.627-.119L17,16.222h-.94l.593-.277h.418l.593-.2.07-.239-.21-.2-.244-.08.07-.239-.175-.355-.418.159.07-.319-.488-.277-.385.677.035.239-.383.159-.244.512-.1-.473-.663-.278-.1-.355.872-.513.383-.355.035-.434-.209-.119-.279-.04-.175.434s-.292.057-.367.076a9.963,9.963,0,0,0-3.34,6.383,5.411,5.411,0,0,0,.326.567l.732.434.732.2.314.4.488.355.279-.039.209.094v.064l-.279.749-.21.319.07.159-.175.591.627,1.145.627.552.279.395-.034.818.21.473-.21.912s-.017-.006.01.085a4.207,4.207,0,0,0,1.186.645l.128-.1-.069-.2.279-.277.1-.277.454-.159.348-.868-.1-.239.244-.355.523-.119.279-.631-.07-.789.418-.592.07-.592c-.572-.284-1.14-.576-1.708-.868",
    style: {
      fill: "#204a87",
      fillOpacity: 0.7134503126144409
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.725,14.015l.348.239h.279v-.278L17,13.816l-.279.2",
    style: {
      fill: "#204a87",
      fillOpacity: 0.7134503126144409
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.819,13.7l-.175.434h.349l.175-.4c.151-.106.3-.214.453-.319l.349.119.7.473.349-.319-.384-.159-.175-.355-.662-.08-.035-.2-.314.08-.139.276-.175-.355-.069.159.035.4-.279.239",
    style: {
      fill: "#204a87",
      fillOpacity: 0.7134503126144409
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.074,12.712l.175-.159.349-.08a5.5,5.5,0,0,1,.732-.277l-.139-.239-.45.065-.213.212-.351.051-.312.147-.151.073-.092.124.453.08",
    style: {
      fill: "#204a87",
      fillOpacity: 0.7134503126144409
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.667,16.461l.21-.319-.314-.239.1.552",
    style: {
      fill: "#204a87",
      fillOpacity: 0.7134503126144409
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.62,30.009a9.23,9.23,0,1,1,9.23-9.232A9.23,9.23,0,0,1,20.62,30.009Zm0-17.971a8.742,8.742,0,1,0,8.742,8.742v0A8.751,8.751,0,0,0,20.62,12.038Z",
    style: {
      opacity: 0.3956044018268585,
      isolation: "isolate",
      fill: "url(#b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.165,17.622a3.28,3.28,0,0,0,5.353-3.791q-.031-.044-.064-.087h0a3.28,3.28,0,0,0-5.29,3.878Z",
    style: {
      fill: "url(#c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.994,16.281a1.011,1.011,0,0,0,1.631-1.2h0a1.011,1.011,0,0,0-1.631,1.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.057,29.226a4.254,4.254,0,0,0,6.913-4.959l-.053-.072h0a4.254,4.254,0,1,0-6.862,5.031Z",
    style: {
      fill: "url(#d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.429,27.485a1.311,1.311,0,1,0,2.115-1.551h0a1.311,1.311,0,1,0-2.115,1.551Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.621,24.2a3.281,3.281,0,0,0,5.293-3.879h0A3.28,3.28,0,0,0,11.625,24.2Z",
    style: {
      fill: "url(#e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.45,22.857a1.011,1.011,0,1,0,1.631-1.2h0a1.011,1.011,0,0,0-1.631,1.2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.638,17.644a3.54,3.54,0,0,0,5.728-4.161l-.019-.026h0a3.54,3.54,0,0,0-5.728,4.161Z",
    style: {
      fill: "url(#f)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.612,16.2a1.091,1.091,0,1,0,1.767-1.281l-.007-.009h0a1.091,1.091,0,0,0-1.767,1.281Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.855,30.372a3.053,3.053,0,0,1-2.319-.866c-.9-.964-.956-2.594-.159-4.588a17.17,17.17,0,0,1,4.23-5.839c4.133-3.868,8.821-5.35,10.674-3.371.9.965.956,2.594.159,4.588a17.178,17.178,0,0,1-4.231,5.839A17.177,17.177,0,0,1,20.1,29.969,7.356,7.356,0,0,1,17.855,30.372Zm10.092-15.11c-2.152,0-5.26,1.521-8.05,4.131a16.738,16.738,0,0,0-4.121,5.688c-.734,1.833-.707,3.3.075,4.134s2.245.956,4.12.348a16.738,16.738,0,0,0,5.946-3.74A16.738,16.738,0,0,0,30.04,20.14c.734-1.833.708-3.3-.076-4.134A2.662,2.662,0,0,0,27.947,15.262Z",
    style: {
      fill: "url(#g)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.029,27.069a16.445,16.445,0,0,1-7.443-2.2c-4.975-2.7-7.866-6.677-6.574-9.06.63-1.162,2.152-1.734,4.3-1.6a17.17,17.17,0,0,1,6.875,2.166,17.172,17.172,0,0,1,5.569,4.58c1.275,1.727,1.635,3.318,1.005,4.48C28.17,26.529,26.809,27.069,25.029,27.069Zm-10.3-12.45c-1.674,0-2.847.488-3.34,1.4-1.157,2.132,1.714,5.937,6.4,8.476s9.439,2.869,10.6.736c.546-1.007.2-2.434-.972-4.019a16.738,16.738,0,0,0-5.428-4.458,16.738,16.738,0,0,0-6.7-2.111Q15,14.62,14.729,14.62Z",
    style: {
      fill: "url(#h)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.719,28.65a2.994,2.994,0,0,1-2.272-.849c-.885-.946-.941-2.542-.159-4.494A16.787,16.787,0,0,1,17.423,17.6c4.043-3.783,8.632-5.231,10.441-3.293h0c1.813,1.938.066,6.418-3.977,10.2a16.785,16.785,0,0,1-5.971,3.746A7.192,7.192,0,0,1,15.719,28.65ZM25.58,13.886c-2.1,0-5.132,1.486-7.855,4.035A16.339,16.339,0,0,0,13.7,23.471c-.717,1.785-.69,3.215.072,4.029s2.188.934,4.015.338a16.349,16.349,0,0,0,5.806-3.652c3.8-3.555,5.574-7.853,3.957-9.58h0A2.6,2.6,0,0,0,25.58,13.886Z",
    style: {
      fill: "url(#i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.706,24.932c-.685,0-1.393-.034-2.119-.106-5.634-.555-9.84-3.1-9.575-5.8h0c.265-2.7,4.888-4.376,10.521-3.819s9.839,3.1,9.574,5.8C29.876,23.357,26.338,24.932,21.706,24.932ZM10.441,19.069c-.239,2.416,3.884,4.806,9.188,5.329s9.813-1.018,10.051-3.434-3.884-4.805-9.189-5.328S10.679,16.654,10.441,19.069Z",
    style: {
      fill: "url(#j)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactsOpen);
export default __webpack_public_path__ + "static/media/contactsOpen.613684f6da9c32cbc34142c23ee85f9f.svg";
export { ForwardRef as ReactComponent };